import { BoardingState } from '.'

export type BoardingAction =
  | {
      type: 'updateUser'
      payload: Partial<BoardingState['user']>
    }
  | {
      type: 'updateOrganization'
      payload: Partial<BoardingState['organization']>
    }

export function boardingReducer(
  state: BoardingState,
  action: BoardingAction
): BoardingState {
  switch (action.type) {
    case 'updateUser':
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      }
    case 'updateOrganization':
      return {
        ...state,
        organization: {
          ...state.organization,
          ...action.payload,
        },
      }
    default:
      return state
  }
}
